interface MicLevelIndicatorProps {
  micLevel: number
}

export function MicLevelIndicator({ micLevel }: MicLevelIndicatorProps) {
  return (
    <div className="pointer-events-none absolute left-2 sm:left-4 top-2 sm:top-4 z-10">
      <div
        className="grid h-8 w-8 sm:h-10 sm:w-10 place-items-center rounded-full bg-primary shadow-md shadow-black/25 ring-1 ring-white/10"
        style={{ transform: `scale(${1 + micLevel * 0.06})` }}
      >
        <div className="flex items-end justify-center gap-0.5">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-[2px] sm:w-[3px] rounded-full bg-white/90 dark:bg-white/70"
              style={{
                height: `${6 + Math.min(14, micLevel * 22) + i * 2}px`,
                animation: `micBars 520ms ease-in-out ${i * 120}ms infinite alternate`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
